import IconComponent from '@/components/icon';
export default {
  install: function install(Vue) {
    Vue.component('Icon', IconComponent);
  }
};